import { create } from 'zustand';

export interface PendingSale {
  session: string;
  key: string;
  body: Record<string, unknown>;
  total: number;
}
const STORAGE = 'sp.submittedSale.v1';
function read(): PendingSale | null {
  try {
    const p = JSON.parse(sessionStorage.getItem(STORAGE) ?? 'null') as PendingSale | null;
    return p &&
      typeof p.session === 'string' &&
      typeof p.key === 'string' &&
      p.body &&
      Number.isSafeInteger(p.total)
      ? p
      : null;
  } catch {
    return null;
  }
}
/** Only an already-submitted attempt is retained. This never queues an offline sale. */
export const useSaleAttempt = create<{ pending: PendingSale | null; set: (p: PendingSale | null) => void }>(
  (set) => ({
    pending: read(),
    set: (pending) => {
      try {
        if (pending) sessionStorage.setItem(STORAGE, JSON.stringify(pending));
        else sessionStorage.removeItem(STORAGE);
      } catch {
        /* beforeunload still protects the in-memory attempt */
      }
      set({ pending });
    },
  }),
);
